import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    evaluacionesProveedores: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    proveedor: null,

    list: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.evaluacionesProveedores = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.proveedor = null;
    },

    'INICIALIZAR_EVALUACIONES' (state) {
        state.evaluacionesProveedores = [];
    },
    'SET_EVALUACIONES' (state, evaluacionesProveedores) {
        state.evaluacionesProveedores = evaluacionesProveedores;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LIST' (state) {
        state.list = [];
    },
    'SET_LIST' (state, list) {
        state.list = list;
    },
};

const getters = {
    getField,

    list (state) {
        return state.list;
    }
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getEvaluaciones ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_EVALUACIONES');

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
                + '&fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                + '&sortByDescending='+ state.sortByDescending;
            
            if (state.proveedor) {
                if (state.proveedor.id != 0) {
                    queryString += '&proveedorId=' + state.proveedor.id;
                }
            }

            apiAxios.get('evaluacionesproveedores' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_EVALUACIONES', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    delete ( {}, evaluacionProveedorId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('evaluacionesproveedores/' + evaluacionProveedorId + '/delete')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    getList ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                + '&sortByDescending='+ state.sortByDescending;
            
            if (state.proveedor) {
                if (state.proveedor.id != 0) {
                    queryString += '&proveedorId=' + state.proveedor.id;
                }
            }

            apiAxios.get('evaluacionesproveedores/list' + queryString)
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}